export const defineAjvCustomKeywords = (ajv) => {
    ajv.addKeyword({
        keyword: 'isNotEmpty',
        type: 'string',
        schemaType: 'boolean',
        validate: function (schema, data) {
            if (typeof data === 'string' && data.trim() !== '') {
                return true;
            }
            return false;
        },
        errors: false,
    });
};
